export default __webpack_public_path__ + "static/media/how1.83bb32e5.png";